module.exports = __webpack_public_path__ + "9f8957eb3d493dd5257280d757d003c8.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@webapp/preact-shared/img/icon-alert-yellow.png
// module id = 276
// module chunks = 7